import { produce, Draft } from 'immer'
import { IAction, TActionTypes } from '@Root/types'

import {
  IProcessingState,
  TProcessingActionTypes,
  ProcessingActionTypes,
  IFetchProcessingInfoSuccessResponseBody,
  IFetchCurrentProcessingStepSuccessResponseBody,
} from './types'

export const initialState: IProcessingState = {
  loading: false,
  attributes: {
    allProcessingSteps: [],
    currentProcessingStep: '',
    projectVersionDuration: 0,
    projectTitle: '',
    projectId: '',
    subtitleId: -1,
    hasVoice: false,
  }
}

type TAction = TActionTypes | TProcessingActionTypes

export const processingReducer = (
  state: IProcessingState = initialState,
  action: TAction
): IProcessingState => {
  return produce(state, draft => {
    switch (action.type) {
      case ProcessingActionTypes.FETCH_PROCESSING_INFO:
        fetchProcessingInfo(draft)
        break

      case ProcessingActionTypes.FETCH_PROCESSING_INFO_SUCCESS:
        fetchProcessingInfoSuccess(draft, action)
        break

      case ProcessingActionTypes.FETCH_PROCESSING_INFO_SUCCESS_FOR_DOWNLOADING:
        fetchProcessingInfoSuccessForDownloading(draft)
        break

      case ProcessingActionTypes.FETCH_CURRENT_PROCESSING_STEP_SUCCESS:
        fetchCurrentProcessingStepSuccess(draft, action)
        break

      default:
        break
    }
  })
}

const fetchProcessingInfo = (draft: Draft<IProcessingState>) => {
  draft.loading = true
}

function isIFetchProcessingInfoSuccessAction(arg: any): arg is IAction<IFetchProcessingInfoSuccessResponseBody> {
  return arg.type === ProcessingActionTypes.FETCH_PROCESSING_INFO_SUCCESS
}

const fetchProcessingInfoSuccess = (draft: Draft<IProcessingState>, action: TAction) => {
  if (!isIFetchProcessingInfoSuccessAction(action)) { return }

  draft.loading = false
  draft.attributes = action.payload.data.attributes
}

const fetchProcessingInfoSuccessForDownloading = (draft: Draft<IProcessingState>) => {
  draft.loading = false
  draft.attributes.currentProcessingStep = 'downloading'
}

function isIFetchCurrentProcessingStepSuccessAction(arg: any): arg is IAction<IFetchCurrentProcessingStepSuccessResponseBody> {
  return arg.type === ProcessingActionTypes.FETCH_CURRENT_PROCESSING_STEP_SUCCESS
}

const fetchCurrentProcessingStepSuccess = (draft: Draft<IProcessingState>, action: TAction) => {
  if (!isIFetchCurrentProcessingStepSuccessAction(action)) { return }

  draft.attributes.currentProcessingStep = action.payload.data.currentProcessingStep
}
